import { IDmLoaiThuNhapHocRequest } from "./../../../model/request/category/dmLoaiThuNhapHocRequest";
import { IDmLoaiThuNhapHocActionTypes } from "../../action-types/category/IDmLoaiThuNhapHocActions";
import { IDmLoaiThuNhapHocReducer } from "../../reducer-model/category/IDmLoaiThuNhapHocReducer";
import { eReducerStatusBase } from "./../../reducer-model/eReducerStatusBase";
import { eMode } from "../../../content/enum";
const iniState: IDmLoaiThuNhapHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiThuNhapHocs: [],
  idSelections: [],
  heNganhChuyenNganhTheoDot: [],
  loaiThuNhapHocTheoDots: [],
  mode: eMode.xem,
  request: {
    dot_nhap_hoc: 0,
  } as IDmLoaiThuNhapHocRequest,
};
export const loaiThuNhapHocReducer = (
  state: IDmLoaiThuNhapHocReducer = iniState,
  action: IDmLoaiThuNhapHocActionTypes,
): IDmLoaiThuNhapHocReducer => {
  switch (action.type) {
    case "LOAI_THU_NHAP_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "LOAI_THU_NHAP_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuNhapHocs: action.payload,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_NHAP_HOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
        loaiThuNhapHocs: [
          ...state.loaiThuNhapHocs.filter(
            (x) => x.id_thu_chi_main !== action.payload.id_thu_chi_main,
          ),
          action.payload,
        ],
      };
    case "LOAI_THU_NHAP_HOC_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiThuNhapHocEditing: action.payload,
      };
    case "LOAI_THU_NHAP_HOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        loaiThuNhapHocEditing: undefined,
      };
    case "LOAI_THU_NHAP_HOC_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_MANY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_MANY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_NHAP_HOC_DELETE_MANY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START":
      return {
        ...state,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS":
      return {
        ...state,
        heNganhChuyenNganhTheoDot: action.payload,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR":
      return {
        ...state,
        heNganhChuyenNganhTheoDot: [],
      };
    case "LOAI_THU_NHAP_HOC_LOAD_THEO_DOT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_THEO_DOT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuNhapHocTheoDots: action.payload,
      };
    case "LOAI_THU_NHAP_HOC_LOAD_THEO_DOT_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_SAVE_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_NHAP_HOC_SAVE_MULTIPLE_SUCCESS":
      const updatedIds = action.payload.map((x) => x.id_thu_chi_main);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuNhapHocTheoDots: [
          ...state.loaiThuNhapHocTheoDots.filter(
            (x) => !updatedIds.includes(x.id_thu_chi_main),
          ),
          // Loại các dòng bị xóa (so_tien < 0) khỏi state -> ô hiển thị trống.
          ...action.payload.filter((x) => x.so_tien >= 0),
        ],
      };
    case "LOAI_THU_NHAP_HOC_SAVE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_NHAP_HOC_CHANGE_VALUE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
